/* eslint no-param-reassign: ["error", { "props": false }]*/

// import Immutable, { Map, List } from 'immutable';
// import { push } from 'react-router-redux';
import { schema, normalize } from 'normalizr';
import { ElementActions } from './element';
import { createActions, asyncAction } from '../helpers/redux';

const userSchema = new schema.Entity('users');
const reportSchema = new schema.Entity('report', {
  user: userSchema,
});

// reportSchema.define({
//   user: userSchema
// });

export const ReportActions = createActions({
  @asyncAction()
  async getReports(projectId) {
    return ({ dispatch, getState, client }) => {
      return client.get('/reports', {
        qs: {
          projectId,
        },
      }).then((response) => {
        const elementIdsToRetrieve = [];
        response.forEach((a) => {
          a.data.forEach((k) => {
            Object.keys(k.data).forEach((g) => {
              if (!getState().elements.hasIn(['elements', g])) {
                elementIdsToRetrieve.push(g);
              }
            });
          });
        });

        if (elementIdsToRetrieve.length > 0) {
          dispatch(ElementActions.getBulkElements(projectId, elementIdsToRetrieve, {
            fields: ['children', 'parent', 'childrenOfChildren', 'consumesFrom', 'providesTo'],
          }));
        }

        return normalize(response, [reportSchema]);
      });
    };
  },

  // @asyncAction()
  // async renameReport(reportId, reportName) {
  //   return ({ client }) =>
  //     client.patch(`/reports/${reportId}`,
  //       { body: { name: reportName } }).then((response) =>
  //         normalize(response, reportSchema)
  //       );
  // },

  @asyncAction()
  async deleteReport(reportId, projectId) {
    return async ({ client }) => {
      const response = await client.delete(`/reports/${reportId}`);
      response.id = reportId;
      response.project_id = projectId;
      // dispatch(push(`/project/${projectId}/reports`));
      return response;
    };
  },

  @asyncAction()
  async getReport(projectId, reportId) {
    return ({ dispatch, getState, client }) => {
      return client.get(`/reports/${reportId}`)
        .then((response) => {
          const elementIdsToRetrieve = [];
          response.data.forEach((a) => {
            Object.keys(a.data).forEach((g) => {
              if (!getState().elements.hasIn(['elements', g])) {
                elementIdsToRetrieve.push(g);
              }
            });
          });

          if (elementIdsToRetrieve.length > 0) {
            dispatch(ElementActions.getBulkElements(projectId, elementIdsToRetrieve, {
              fields: ['children', 'parent', 'childrenOfChildren', 'consumesFrom', 'providesTo'],
            }));
          }

          return normalize(response, reportSchema);
        }
      );
    };
  },

  @asyncAction()
  async runReport(projectId, reportId) {
    return async ({ dispatch, getState, client }) => {
      const response = await client.get(`/reports/${reportId}/run`);
      const elementIdsToRetrieve = [];
      response.forEach((a) => {
        Object.keys(a.data).forEach((g) => {
          if (!getState().elements.hasIn(['elements', g])) {
            elementIdsToRetrieve.push(g);
          }
        });
      });

      if (elementIdsToRetrieve.length > 0) {
        dispatch(ElementActions.getBulkElements(projectId, elementIdsToRetrieve, {
          fields: ['children', 'parent', 'childrenOfChildren', 'consumesFrom', 'providesTo'],
        }));
      }
      return { response, reportId };
    };
  },

  @asyncAction()
  async createReport(reportConfig) {
    return async ({ getState, client }) => {
      const projectId = getState().projects.get('currentProjectId');
      reportConfig.projectId = projectId;

      // need to check the report type here
      const type = reportConfig.type;
      if (type === 'Daily Task Complete') {
      } else if (type === 'Test Ranking') {
        if (!reportConfig.idm) {
          reportConfig.idm = {
            hierarchy: 0.9,
          };

          reportConfig.implementationIds.forEach(id => {
            reportConfig.idm[id] = {};

            reportConfig.implementationIds.forEach(mapId => {
              reportConfig.idm[id][mapId] = 0.5;
            });

            reportConfig.requirementIds.forEach(mapId => {
              reportConfig.idm[id][mapId] = 0.7;
            });

            reportConfig.folderIds.forEach(mapId => {
              reportConfig.idm[id][mapId] = 0.2;
            });

            reportConfig.testIds.forEach(mapId => {
              reportConfig.idm[id][mapId] = 0.9;
            });
          });

          reportConfig.folderIds.forEach(id => {
            reportConfig.idm[id] = {};

            reportConfig.implementationIds.forEach(mapId => {
              reportConfig.idm[id][mapId] = 0.5;
            });

            reportConfig.requirementIds.forEach(mapId => {
              reportConfig.idm[id][mapId] = 0.7;
            });

            reportConfig.folderIds.forEach(mapId => {
              reportConfig.idm[id][mapId] = 0.2;
            });

            reportConfig.testIds.forEach(mapId => {
              reportConfig.idm[id][mapId] = 0.9;
            });
          });

          reportConfig.requirementIds.forEach(id => {
            reportConfig.idm[id] = {};

            reportConfig.requirementIds.forEach(mapId => {
              reportConfig.idm[id][mapId] = 0.5;
            });

            reportConfig.implementationIds.forEach(mapId => {
              reportConfig.idm[id][mapId] = 0.7;
            });

            reportConfig.folderIds.forEach(mapId => {
              reportConfig.idm[id][mapId] = 0.2;
            });

            reportConfig.testIds.forEach(mapId => {
              reportConfig.idm[id][mapId] = 0.9;
            });
          });

          reportConfig.testIds.forEach(id => {
            reportConfig.idm[id] = {};

            reportConfig.testIds.forEach(mapId => {
              reportConfig.idm[id][mapId] = 0.9;
            });
          });
        }
      }

      const response = await client.post(`/projects/${projectId}/reports`, {
        body: reportConfig,
      });
      return normalize(response, reportSchema);
    };
  },
});



// WEBPACK FOOTER //
// ./src/actions/report.js